"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torregrotta": {
    "d1599056": [{
      "hkey": "45bc2f29",
      "slug": "torregrotta",
      "name": "Torregrotta",
      "primary": true,
      "skipSearch": false
    }],
    "crocieri": [{
      "hkey": "45bc2f29",
      "slug": "torregrotta",
      "name": "Torregrotta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b262af5b": [{
      "hkey": "45bc2f29",
      "slug": "torregrotta",
      "name": "Torregrotta",
      "primary": true,
      "skipSearch": false
    }],
    "grotta": [{
      "hkey": "45bc2f29",
      "slug": "torregrotta",
      "name": "Torregrotta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "99b21b7e": [{
      "hkey": "45bc2f29",
      "slug": "torregrotta",
      "name": "Torregrotta",
      "primary": true,
      "skipSearch": false
    }],
    "scala": [{
      "hkey": "45bc2f29",
      "slug": "torregrotta",
      "name": "Torregrotta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;